// 관리자 로그인 토큰을 브라우저에 보관/조회/삭제하는 도우미입니다.
//
// 예전엔 로그인 세션을 쿠키로 관리했는데, admin 프론트(예: admin.apsp.co.kr)와
// 서버(Railway 기본 도메인)가 서로 다른 사이트라서 그 쿠키가 "제3자 쿠키"로
// 취급되어 브라우저(특히 Safari, Chrome 시크릿 모드)가 차단했습니다. 그래서
// 로그인은 성공하는데 바로 다음 화면에서 로그아웃 상태로 보이는 문제가
// 있었습니다. 쿠키 대신 로그인 성공 시 받은 토큰을 여기 저장해두고,
// 매 요청마다 직접 헤더에 실어 보내는 방식으로 바꿔서 이 문제를 피합니다.
const TOKEN_KEY = "apsp_admin_token";

export function getAdminToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAdminToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
}

export function clearAdminToken() {
  localStorage.removeItem(TOKEN_KEY);
}
